import { render } from "./languageView.vue?vue&type=template&id=63cbb6f6&scoped=true"
import script from "./languageView.vue?vue&type=script&lang=js"
export * from "./languageView.vue?vue&type=script&lang=js"

import "./languageView.vue?vue&type=style&index=0&id=63cbb6f6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cbb6f6"]])

export default __exports__